import React from 'react';
import { GenericInputProps } from 'shared/types/commonPropTypes';

type InputProps = {
  placeholder?: string;
};

const InputWidget = (props: GenericInputProps & InputProps) => {
  const { dataOptions, option, inputType, value } = props;
  let timeout: NodeJS.Timeout;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { option, isArraySelector, index } = props;
    const val = e.target.value;

    if (option && option.timeout) {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        props.onChange({ val });
      }, option.timeout);
    } else if (isArraySelector) props.onChange({ val, index });
    else props.onChange({ val });
  };

  const onDataChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onDataChange) props.onDataChange(e.target.value, e.target.getAttribute('index') ?? '', 'image');
  };

  if (option?.isBasedOnData) {
    return (
      <div>
        {dataOptions.map((option: any, i: number) => {
          return (
            <span key={i}>
              <div className="data-option-label">
                {' '}
                {option.arrayLabel} {i + 1}
              </div>
              {/* TODO: Change this to be more generic, only works for image right now */}
              <input type={inputType} value={option.image ?? ''} onChange={onDataChange} />
            </span>
          );
        })}
      </div>
    );
  }
  return (
    <div className={`${props.label ? 'mt-2 w-full' : ''} ${props.className}`} id={props.option?.id}>
      {option?.image && <img src={`https://app.everviz.com/static/editor/${option?.image}`} />}
      {props.label && <div className="text-ev-navy-blue font-bold mb-2">{props.label}</div>}
      <input
        className={`${props.className} ${props.option?.inputClassName} highed-field-input`}
        type={inputType}
        value={(value ?? '') as string}
        onChange={onChange}
        onKeyDown={props.onKeyDown}
        placeholder={props.placeholder}
      />
    </div>
  );
};

export default InputWidget;
